
import { getOwnerById } from 'store/owners/actions'
import type { OwnerDataResponse, GetOwnerByIdPayload } from 'store/owners/types'
import { useSelector } from 'store/hooks'

import type { UseQuerySelectOptions, UseQuerySelectResult } from 'hooks'

import { useQuerySelect } from 'hooks'


type UseOwnerParams = GetOwnerByIdPayload

type UseOwnerResult = {
  data: OwnerDataResponse | null
} & UseQuerySelectResult<UseOwnerParams>

export const useOwner = (params: UseOwnerParams, options?: UseQuerySelectOptions): UseOwnerResult => {
  const result = useQuerySelect(getOwnerById, params, options)
  const data = useSelector(state => state.owners.owner)

  return {
    data,
    ...result,
  }
}
